import type { ButtonHTMLAttributes, ReactNode } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: "ink" | "outline";
}

export function PrimaryButton({ children, variant = "ink", className = "", ...rest }: Props) {
  const base =
    "flex w-full h-[54px] items-center justify-center gap-2 rounded-[18px] text-[12px] font-semibold tracking-[0.24em] uppercase transition-opacity active:opacity-80 disabled:opacity-50";
  const skin =
    variant === "ink" ? "bg-ink text-paper" : "border border-ink/35 text-ink bg-transparent";
  return (
    <button className={`${base} ${skin} ${className}`} {...rest}>
      {children}
    </button>
  );
}
